import { makeStyles } from '@material-ui/core/styles';

import transparentize from '@utils/transparentize';

const useStyles = makeStyles((theme) => ({
  questionsWrapper: {
    marginTop: 40,
  },
  question: {
    backgroundColor: 'transparent',
    marginBottom: 16,
    boxShadow: 'none',
    '& i': {
      fontSize: 8,
      color: theme.palette.info.main,
    },
    '& li': {
      marginBottom: 8,
      '&::marker': {
        fontSize: 18,
        color: theme.palette.secondary.dark,
      },
      '& *': {
        display: 'inline-flex',
      },
    },
    '&:before': {
      display: 'none',
    },
  },
  summary: {
    padding: 0,
    '& > div:first-of-type': {
      margin: 0,
    },
    '&.Mui-expanded': {
      minHeight: 48,
    },
  },
  details: {
    marginTop: 8,
    padding: 0,
    flexDirection: 'column',
  },
  [theme.breakpoints.up('sm')]: {
    questionsWrapper: {
      paddingRight: 123,
    },
    link: {
      marginTop: 16,
    },
    button: {
      marginTop: 24,
    },
  },
  [theme.breakpoints.up('md')]: {
    questionsWrapper: {
      paddingRight: 0,
      display: 'grid',
      gap: 30,
      marginTop: 16,
      gridTemplateColumns: '5fr 9fr',
    },
    leftColumn: {
      marginTop: 16,
    },
    sticky: {
      borderRadius: 16,
      backgroundColor: theme.palette.background.default,
      padding: '32px 0',
      position: 'sticky',
      top: 20,
    },
    answer: {
      paddingTop: 24,
      marginBottom: 29,
      '& h6': {
        marginBottom: 8,
      },
      '& p': {
        display: 'inline',
        paddingRight: '0.5ch',
      },
      '& li::marker': {
        fontSize: 18,
        color: theme.palette.secondary.dark,
      },
    },
    questionButton: {
      width: '100%',
      height: 'unset',
      textAlign: 'left',
      border: 'none',
      padding: '16px 24px',
      display: 'block',
      borderRadius: 0,
      transition: 'all 0.3s linear',
      '&::before, & p': {
        transition: 'all 0.3s linear',
      },
      '&.active': {
        position: 'relative',
        backgroundColor: transparentize(theme.palette.primary.main, 0.25),
        '&::before': {
          backgroundColor: theme.palette.primary.dark,
          borderTopRightRadius: 16,
          borderBottomRightRadius: 16,
          content: '""',
          display: 'block',
          height: '100%',
          width: 8,
          position: 'absolute',
          top: 0,
          left: 0,
        },
        '& p': {
          fontWeight: 700,
          color: theme.palette.primary.dark,
        },
      },
    },
  },
  [theme.breakpoints.up('lg')]: {
    questionsWrapper: {
      gap: 125,
    },
    sticky: {
      '&:after': {
        backgroundColor: transparentize(theme.palette.info.main, 0.3),
        content: '""',
        position: 'absolute',
        top: 0,
        display: 'block',
        right: -62,
        width: 1,
        height: '100%',
      },
    },
  },
}));

export default useStyles;
